import { ReplyUpdateModelBase } from './reply-update-model-base.model';
import { AttachmentBase } from './attachment-base.model';

export class ReplyUpdateModel extends ReplyUpdateModelBase {
    attachments: AttachmentBase[];

    isNeedToBeSentByEmail?: boolean;

    isSendingReply?: boolean; // GUI property

    isShowNewSubreplyForm?: boolean; // GUI property

    newAttachments?: AttachmentBase[]; // GUI property

    // constructor();
    constructor(reply?, parentReplyId?, ccEmails?, toEmails?, bccEmails?, isNeedText?) {
        if (reply) {
            super(reply, parentReplyId, ccEmails, toEmails, bccEmails, isNeedText);
            //   super();
            this.attachments = reply.attachments;
        } else {
            super();

            this.attachments = [];
        }

        this.newAttachments = [];
    }

    static reset(reply: ReplyUpdateModel) {
        reply.message.text = '';
        reply.message.html = '';

        reply.attachments = [];
    }
}
